import BigNumber from "bignumber.js";
export function serializeHederaTransaction({ amount, family, memo = undefined, recipient, }) {
    return {
        amount: amount.toString(),
        family,
        memo,
        recipient,
    };
}
export function deserializeHederaTransaction({ amount, family, memo = undefined, recipient, }) {
    return {
        amount: new BigNumber(amount),
        family,
        memo,
        recipient,
    };
}
